<template>
    <div id="photo-selector-from-file"
         class="modl-tab-body">
        <div class="modl-body">
            <div class="photo-selector-modal__layout">
                <div v-if="photoData"
                     class="photo-selector-modal__img-preview">
                    <img :src="photoData" />
                </div>

                <div class="photo-selector-modal__btn-section">
                    <div class="photo-selector-from-file__input-container">
                        <input ref="file-input"
                               type="file"
                               accept="image/jpeg, image/png, image/jpg" />

                        <a v-if="photoData"
                           class="btn btn-danger btn-lg btn-block">
                            <i class="fa-regular fa-file-upload"></i> {{ l('PHOTO_SELECTOR.RESELECT_FILE') }}
                        </a>
                        <a v-else
                           class="btn btn-primary btn-lg btn-block">
                            <i class="fa-regular fa-file-upload"></i> {{ l('PHOTO_SELECTOR.SELECT_FILE') }}
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="modl-footer">
            <!-- Cancel button -->
            <button class="btn btn-lg btn-default cancel-btn"
                    @click.prevent="$emit('cancel')">
                {{ l('CANCEL') }}
            </button>

            <!-- OK button -->
            <button v-if="photoData"
                    class="btn btn-lg btn-primary"
                    @click.prevent="$emit('resolve', { photoData });">
                {{ l('PHOTO_SELECTOR.USE_PHOTO') }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    emits: [
        'cancel',
        'resolve',
    ],

    data() {
        return {
            photoData: null,
        };
    },

    mounted() {
        // We have to use self here and a non-arrow function so that 'this' in the event listener
        // refers to the file input.
        const self = this;

        this.$refs['file-input'].addEventListener('change', function () {
            const reader = new FileReader();
            reader.addEventListener('load', () => {
                self.photoData = reader.result;
            });
            reader.readAsDataURL(this.files[0]);
        });
    },

    methods: {
        clear() {
            this.photoData = null;
        },
    },
};
</script>

<style lang="less">
.photo-selector-from-file__input-container {
    position: relative;

    input {
        width: 100%;
        height: 48px;

        // Position the file input on top of the button but invisible.
        z-index: 1;
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
    }
}
</style>
